import React, { useState, useEffect, useRef } from "react";
import Spinner from "./Spinner";

const RelatedProducts = ({ productCode }) => {
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const hasCalledAPI = useRef(false);

    useEffect(() => {
        const tabBtn = document.querySelector("#product-tab4");
        const hash = window.location.hash.substring(1);

        const handleTabClick = () => {
            if (!hasCalledAPI.current) {
                getRelatedProducts();
            }
        };

        tabBtn?.addEventListener("click", handleTabClick);

        if (hash.toLowerCase().includes("relatedproducts") && !hasCalledAPI.current) {
            getRelatedProducts();
        }

        return () => {
            tabBtn?.removeEventListener("click", handleTabClick);
        };
    }, []);

    const getRelatedProducts = () => {
        if (hasCalledAPI.current) return;

        setLoading(true);
        hasCalledAPI.current = true;
        fetch(i18n.baseUrl + `api/relatedproducts/relatedproducts?productCode=${productCode}`)
            .then((res) => res.json())
            .then((json) => {
                setRelatedProducts(json);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching relatedproducts:", error);
                setLoading(false);
            });
    };

    return (
        <div className="c-series c-series__listing">
            {loading && <Spinner />}
            {relatedProducts.map((rp) => (
                <div className="c-series__item" key={rp.productName}>
                    <div className="c-series-card">
                        <div className="c-series-card__outer">
                            <div className="c-series-card__inner">
                                <a className="stretched-link" href={rp.productUrl}>
                                    <div>
                                        <img src={`${i18n.CdnHostName}${rp.productImageUrl}?preset=c-series-list&width=170`} alt={rp.productName} />
                                    </div>
                                    {rp.productTags.length ? <div className="c-product-card__tag">{rp.productTags[0]}</div> : null}
                                    <h4 className="c-series-card__heading">{rp.productName}</h4>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RelatedProducts;